export const COMPANY_FORM_DEFAULT_PARAMS = Object.freeze({
  route: 'general-data',
});

export const COMPANY_FILTER_FORM_DEFAULT_PARAMS = Object.freeze({
  hlbClientStatus: undefined,
  createdAt: undefined,
  updatedAt: undefined,
  city: undefined,
  country: undefined,
  market: undefined,
  'applicationSettings.isHr': undefined,
  'applicationSettings.isForEmployees': undefined,
  'applicationSettings.eInvoice': undefined,
  'applicationSettings.typeOfCompany': undefined,
  'applicationSettings.isSector': undefined,
  'applicationSettings.foreignWorkPermitTracker': undefined,
  'applicationSettings.holidayDaysTracker': undefined,
  'generalData.email': undefined,
  'generalData.code': undefined,
  'generalData.city': undefined,
  'generalData.pib': undefined,
});

export const COMPANY_DEFAULT_PARAMS = Object.freeze({
  offset: '1',
  limit: '10',

  // filters
  _id: undefined,
  'generalData.address': undefined,
  'clientsAdmins.clients': undefined,
  'clientsAdmins.companyAdmins': undefined,

  // sorters
  sort_id: undefined,
  sortCompany: undefined,
  sortAddress: undefined,
  sortClients: undefined,
  sortCompanyAdmins: undefined,
  sortCreatedAt: undefined,
  sortUpdatedAt: undefined,

  ...COMPANY_FORM_DEFAULT_PARAMS,
  ...COMPANY_FILTER_FORM_DEFAULT_PARAMS,
});
